import {cs}        from "@Common/react/chain-services";
import {Effect}    from "@Common/react/effect";
import {fragments} from "@Common/react/fragments";
import {Static}    from "@Common/react/static";
import {UseState}  from "@Common/react/use-state";
import {reverse, sort} from "@Common/utils/collections";
import {entries}   from "@Common/utils/objects";
import {chain} from "@Common/utils/fs";
import { Static2 } from "@Common/react/static-2";

export const ScrollControl2 = ({next}) => cs(
    ["refs", (_, next) => Static({getInitValue: () => ({}), next})],
    ["headerRef", (_, next) => Static2({next})],
    ["focused", (_, next) => UseState({next})],
    ({refs, focused, headerRef}) => fragments(
        next({
            header: {
                isActive: (name) => name === focused.value,
                scrollTo: (name) => {
                    const parentRect = headerRef.get().parentNode.getBoundingClientRect();
                    window.scrollTo({
                        top: (
                            refs[name].getBoundingClientRect().top - parentRect.top
                        ),
                        behavior:"smooth",
                    })
                },
                hasContent: (name) => !!refs[name],
                ref: headerRef.set,
            },
            content: {
                ref: (name) => (dom) => refs[name] = dom,
            },
        }),

        Effect({
            action: () => {

                const listener = () => {
                    // Get the scrolltop value and adding 50 to it
                    const scrollTop = (
                        document.documentElement.scrollTop ? (
                            document.documentElement.scrollTop
                        ): (
                            document.body.scrollTop
                        )
                    ) + 50;

                    const col = chain(
                        entries(refs),
                        (_) => _.map(([name, dom]) => dom && ({name, dom, rect: dom.getBoundingClientRect()})).filter(v=>v),
                        (_) => sort(_, ({rect}) => rect.y),
                        reverse,
                    );
                    for (const {name, dom} of col) {
                        const offsetTop = dom.offsetTop - 100;
                        if(scrollTop >= offsetTop) {
                            if (focused.value !== name) {
                                focused.onChange(name)
                            }
                            break;
                        }
                    }
                };

                window.addEventListener("scroll", listener);
                return () => window.removeEventListener("scroll", listener);
            },
        })
    ),
);
